import React, { useEffect, useState } from 'react'

import { Col, Row } from 'reactstrap'
import firebase from "../../firebase/firebase-config";
import Archive_icon from './Archive_icon';
import SingleFeedback from './SingleFeedback';
const ListFeedbacks = () => {
    const [all_feedbacks, setall_feedbacks] = useState([])
    const [query, setquery] = useState('')


    const get_all_feedbacks = () => {
        firebase.firestore().collection('feedBack').onSnapshot((feedback) => {
            const all_feedbacks_data = [];
            feedback.forEach(element => {
                all_feedbacks_data.push(element.data());
            });
            setall_feedbacks(all_feedbacks_data);

        })


    }
    useEffect(() => {
        get_all_feedbacks();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="10">
                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}
                                    </span>
                                </div>

                            </div>

                        </div>


                    </Col>
                    <div className='d-flex justify-content-center align-items-center'>
                        <Archive_icon width='3em' height='3em' />
                    </div>

                </Row>
                <div className='mt-4'>
                    <div className=" ">
                        {all_feedbacks.map((feed) => {

                            return <SingleFeedback data={feed} />
                        })}



                    </div>

                </div>


            </div>

        </>
    )
}

export default ListFeedbacks